// extracted by mini-css-extract-plugin
export var createdDate = "_mv-1";
export var divider = "_mv-2";
export var headerDivider = "_mv-3";
export var messagesCard = "_mv-0";
export var messagesContainer = "_mv-7";
export var messagesContainerWrapper = "_mv-4";
export var pointerCapturingButtonBoxes = "_mv-a";
export var showLeftPanelButton = "_mv-9";
export var showMoreButton = "_mv-c";
export var showMoreButtonContainer = "_mv-b";
export var summaryTitle = "_mv-6";
export var systemMessageCardWrapper = "_mv-d";
export var topButtons = "_mv-8";
export var withPadding = "_mv-5";